import React, {useCallback, useEffect, useMemo, useState} from 'react';
import "../../../rise/styles/normalize.css";
import '../../styles/fonts.scss';
import Container from "../../components/Container";
import ChapterRenderer from "../../components/ChapterRenderer";
import {getChannelInfo} from '../../../rise/hyperlive/utils';
import {ChapterType, prepareShowRunner} from "../../shared";
import WrapAnimatePresence from "../../components/WrapAnimatePresence";
import {ShowRunnerContext} from '../../contexts/ShowRunner';
import './style.scss';
import {renderOptions} from "../core/app";
import { listenForTakeover } from '../../../../services/takeover-service/utils';
import { Simulate } from 'react-dom/test-utils';
import play = Simulate.play;


export default function App({data = {}, config}) {
    const [activeChapter, setActiveChapter] = useState<null | number>(null);
    const [chapters, setChapters] = useState<Array<ChapterType>>([]);
    const [isLooping, setIsLooping] = useState(false);

    const {takeoverWidth, takeoverHeight} = useMemo(() => {
        return  {
            takeoverWidth: getChannelInfo('json_config.store_takeover.width', Math.round(window.innerWidth)),
            takeoverHeight: getChannelInfo('json_config.store_takeover.height', Math.round(window.innerHeight)),
        }
    }, []);

    useEffect(() => {
        prepareShowRunner(data, config).then((c) => {
            setChapters(c);
            listen();
        });
    }, []);

    const playChapter = useCallback((chapter) => {
        setActiveChapter(chapter);
    }, [chapters]);
    
    const listen = useCallback(() => {
        console.log('[takeover] listening for takeover');
        const clean = listenForTakeover('FULL_TAKEOVER', ({type, chapter, isLooping}) => {
            setIsLooping(isLooping);
            
            if (type === 'start') {
                playChapter(0);
                console.log('[takeover] starting')
            } else {
                console.log('[takeover] stop');
                setActiveChapter(null);
            }
        });

        return () => clean();
    }, [chapters]);

    // @TODO: remove some duplicate stuff right here.
    const contextMethods = useMemo(() => {
        if (chapters.length === 0) {
            return;
        }

        const activeChapterIndex = activeChapter === null ? null : activeChapter % chapters.length;

        return {
            chapters,
            activeChapterIndex,
            getActiveChapter: () => chapters[activeChapterIndex],
        }
    }, [chapters, activeChapter]);

    useEffect(() => {
        if (isLooping) {
            console.log('[takeover] looping and so we are not stopping');
            return;
        }
        
        if (!activeChapter && activeChapter !== 0) {
            // stopped
            console.log('[takeover] stopped because activeChapter is null');
            return;
        }

        setTimeout(() => {
            console.log('[takeover] stopping because duration is over');
            setActiveChapter(null);
        }, contextMethods.chapters?.[activeChapter]?.duration);

    }, [activeChapter, isLooping])

    if (chapters.length === 0 || !contextMethods.getActiveChapter() || activeChapter === null) {
        return null;
    }

    return (
        <Container
            framed={true}
            width={takeoverWidth}
            height={takeoverHeight}
        >
            <ShowRunnerContext.Provider value={contextMethods as any}>
                <WrapAnimatePresence>
                    <ChapterRenderer
                        renderOptions={renderOptions}
                        key={contextMethods.activeChapterIndex}
                        index={contextMethods.activeChapterIndex}
                        chapter={contextMethods.getActiveChapter()}
                        config={config}
                    />
                </WrapAnimatePresence>
            </ShowRunnerContext.Provider>
        </Container>
    )
}